"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRatingFeedback = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledRatingFeedback = _styledComponents.default.div.withConfig({
  displayName: "RatingFeedbackstyles__StyledRatingFeedback",
  componentId: "sc-1oiautd-0"
})([".c-rating-feedback-input{height:4rem;}.c-rating-feedback-response{margin:0;}"]);

exports.StyledRatingFeedback = StyledRatingFeedback;